import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse
} from "@angular/common/http";
import {
  Observable,of,throwError
} from 'rxjs';
import { tap, catchError } from "rxjs/operators";
import {ToastrService} from 'ngx-toastr';

import { AccountService } from "../_services/account.service";
@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(public toasterService: ToastrService,public accountService:AccountService) {}
intercept(
        req: HttpRequest<any>,
        next: HttpHandler
      ): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap(evt => {
                if (evt instanceof HttpResponse) {
                    if(evt.body && evt.body.success){}
                        //this.toasterService.success(evt.body.success.message, evt.body.success.title, { positionClass: 'toast-bottom-center' });
                }
            }),
            catchError((err: any) => {
                if(err instanceof HttpErrorResponse) {
                    let errorMessage: string;
                   
                        switch (err.status) {
        case 400:
          errorMessage = "Bad Request.";
          break;
        case 401:
          errorMessage = "You need to log in to do this action.";
          break;
        case 403:
          errorMessage = "You don't have permission to access the requested resource.";
          break;
        case 404:
          errorMessage = "The requested resource does not exist.";
          break;
        case 412:
          errorMessage = "Precondition Failed.";
          break;
        case 500:
          errorMessage = "Internal Server Error.";
          break;
        case 503:
          errorMessage = "The requested service is not available.";
          break;
        case 422:
          errorMessage = "Validation Error!";
          break;
        default:
          errorMessage = "Something went wrong!";
      }
                    try {
                       this.toasterService.error(errorMessage, "", { positionClass: 'toast-center-center',
      tapToDismiss: true,timeOut:3000});
                    } catch(e) {
                        this.toasterService.error(errorMessage, "", { positionClass: 'toast-center-center',
      tapToDismiss: true,timeOut:3000  });
                    }
                    //log error 
                }
                return throwError(err);
            }));
    
      }
}